var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container vip-customer-page" }, [
    _c(
      "div",
      { staticClass: "vip-customer-page__panel" },
      [
        _c("BjPage", {
          ref: "leftPage",
          attrs: {
            "auto-fetch": false,
            "query-params": _vm.leftQueryParams,
            "col-span": 6,
            "search-btn-span": 6,
            "get-action": _vm.queryApi,
            radio: true,
            serial: false,
            "row-key": "id",
            "before-reset-search": _vm.beforeLeftResetSearch,
          },
          on: {
            handleRadioChange: _vm.handleLeftRadioChange,
            showSetting: _vm.showLeftSetting,
            "header-dragend": _vm.handleLeftHeaderDragend,
            "header-contextmenu": _vm.handleLeftHeaderContextmenu,
          },
          scopedSlots: _vm._u([
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.Supplier"),
                            prop: "quoteId",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.Supplier"
                              ),
                            },
                            model: {
                              value: _vm.leftQueryParams.quoteId,
                              callback: function ($$v) {
                                _vm.$set(_vm.leftQueryParams, "quoteId", $$v)
                              },
                              expression: "leftQueryParams.quoteId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.remarkText"),
                            prop: "remark",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: { placeholder: _vm.$t("table.remarkText") },
                            model: {
                              value: _vm.leftQueryParams.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.leftQueryParams, "remark", $$v)
                              },
                              expression: "leftQueryParams.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.customerCode"),
                            prop: "clientCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.customerCode"
                              ),
                            },
                            model: {
                              value: _vm.leftQueryParams.clientCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.leftQueryParams, "clientCode", $$v)
                              },
                              expression: "leftQueryParams.clientCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.leftColumns, function (col, index) {
                    return [
                      _c("vxe-column", {
                        key: "left_col_" + index + "_" + col.prop,
                        attrs: {
                          field: col.prop,
                          title: col.label,
                          width: col.width || "auto",
                          align: "center",
                          "show-overflow": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCellValue(row, col, "left")
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "vip-customer-page__panel",
        class: { "is-disabled": _vm.isRightDisabled },
      },
      [
        _c("BjPage", {
          ref: "rightPage",
          attrs: {
            "auto-fetch": false,
            "query-params": _vm.rightQueryParams,
            "col-span": 6,
            "search-btn-span": 6,
            "get-action": _vm.rightQueryApi,
            selection: true,
            serial: false,
            "row-key": "id",
            "before-reset-search": _vm.beforeRightResetSearch,
          },
          on: {
            handleSelectionChange: _vm.handleRightSelectionChange,
            showSetting: _vm.showRightSetting,
            "header-dragend": _vm.handleRightHeaderDragend,
            "header-contextmenu": _vm.handleRightHeaderContextmenu,
          },
          scopedSlots: _vm._u([
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.customerCode"),
                            prop: "clientCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: 800,
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.customerCode"
                              ),
                              disabled: _vm.isRightDisabled,
                            },
                            model: {
                              value: _vm.rightQueryParams.clientCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rightQueryParams,
                                  "clientCode",
                                  $$v
                                )
                              },
                              expression: "rightQueryParams.clientCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.customerName"),
                            prop: "realName",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.customerName"
                              ),
                              disabled: _vm.isRightDisabled,
                            },
                            model: {
                              value: _vm.rightQueryParams.realName,
                              callback: function ($$v) {
                                _vm.$set(_vm.rightQueryParams, "realName", $$v)
                              },
                              expression: "rightQueryParams.realName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.Status"),
                            prop: "status",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.Status"
                              ),
                              "option-list": _vm.bindStatusList,
                              disabled: _vm.isRightDisabled,
                            },
                            on: { change: _vm.handleRightQuery },
                            model: {
                              value: _vm.rightQueryParams.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.rightQueryParams, "status", $$v)
                              },
                              expression: "rightQueryParams.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "tableOperation",
              fn: function (tableOperationProp) {
                return [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            plain: "",
                            disabled:
                              _vm.isRightDisabled ||
                              tableOperationProp.notSelected ||
                              _vm.hasSelectedStatus(true),
                          },
                          on: { click: _vm.onBind },
                        },
                        [_vm._v(_vm._s(_vm.$t("QuotationCustomerLang.bind")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            plain: "",
                            disabled:
                              _vm.isRightDisabled ||
                              tableOperationProp.notSelected ||
                              _vm.hasSelectedStatus(false),
                          },
                          on: { click: _vm.onUnbind },
                        },
                        [_vm._v(_vm._s(_vm.$t("QuotationCustomerLang.unbind")))]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.rightColumns, function (col, index) {
                    return [
                      _c("vxe-column", {
                        key: "right_col_" + index + "_" + col.prop,
                        attrs: {
                          field: col.prop,
                          title: col.label,
                          width: col.width || "auto",
                          align: "center",
                          "show-overflow": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCellValue(row, col, "right")
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }